import type { ReviewRuleCategory } from '~/data/schemas/documentReview';

export interface ReviewRuleCategoryConfig {
  value: ReviewRuleCategory;
  label: string;
  addLabel: string;
  ruleColumnLabel: string;
  rulePlaceholder: string;
}

// The extractor folds included services, excluded services, miscellaneous
// charges and other terms into the same list as the billing rules, telling
// them apart by category. Shared by the contract edit form and the extraction
// review wizard so both name the categories the same way (AMP-763).
//
// Keyed by category with `satisfies Record<...>`: a category added to
// `reviewRuleCategorySchema` without an entry here fails typecheck. Both wizard
// steps filter rows by strict equality against these sections, so a missing
// entry would hide rows that `toApprovePayload` still submits.
const REVIEW_RULE_CATEGORY_CONFIG = {
  'review-rule': {
    value: 'review-rule',
    label: 'Review Rules',
    addLabel: 'Add Review Rule',
    ruleColumnLabel: 'Review Rule',
    rulePlaceholder: 'Review rule...',
  },
  'included-service': {
    value: 'included-service',
    label: 'Included Services',
    addLabel: 'Add Included Service',
    ruleColumnLabel: 'Service',
    rulePlaceholder: 'Service...',
  },
  'excluded-service': {
    value: 'excluded-service',
    label: 'Excluded Services',
    addLabel: 'Add Excluded Service',
    ruleColumnLabel: 'Service',
    rulePlaceholder: 'Service...',
  },
  'miscellaneous-charge': {
    value: 'miscellaneous-charge',
    label: 'Miscellaneous Charges',
    addLabel: 'Add Misc Charge',
    ruleColumnLabel: 'Charge',
    rulePlaceholder: 'e.g., trip $75 per-trip: Hauling fee (always billable)',
  },
  'other-term': {
    value: 'other-term',
    label: 'Other Terms',
    addLabel: 'Add Other Term',
    ruleColumnLabel: 'Term',
    rulePlaceholder: 'Term...',
  },
} satisfies Record<ReviewRuleCategory, ReviewRuleCategoryConfig>;

// Section order is the key order above (string keys keep insertion order).
export const REVIEW_RULE_SECTIONS: ReviewRuleCategoryConfig[] = Object.values(
  REVIEW_RULE_CATEGORY_CONFIG,
);
